<template>
    <Container class="px-[18px]">
        <div v-html="content"></div>
    </Container>
</template>

<script>
import Container from '../../../Layouts/Container.vue'

export default {
    components: {
        Container
    },
    props: {
        content: {
            type: String,
            default: ''
        }
    }
}
</script> 